import React from "react";
import NotFound from "../pages/NotFound";
import DashboardLayout from "../components/layout/DashboardLayout";
const Home = React.lazy(() => import("../pages/landing-page/Home"));

// routes/RouteConfig.js
const getRoutes = () => {
  return  [
  {
    path: "/",
    title: "Home",
    component: Home,
    exact: true,
    private: false,
    layout: DashboardLayout,
  },

  { path: "*", title: "", component: NotFound, layout: null }, // Catch-all route
]
}

export default getRoutes;
